import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-start space-y-1" }
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", { class: "bg-gray-lp-600" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!

  return (_openBlock(), _createBlock(_component_TooltipV2, {
    icon: "ellipsis",
    width: "180",
    disabled: _ctx.disabled
  }, {
    default: _withCtx((tooltip) => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_LpButton, {
          title: _ctx.$t('dashboard.console.common.viewDetail'),
          iconV2: "",
          iconLeft: "file-chart",
          textColor: "black-lp-300",
          textSize: 14,
          flat: "",
          dense: "",
          onClick: ($event: any) => (_ctx.toDetail(_ctx.data, tooltip))
        }, null, 8, ["title", "onClick"]),
        _hoisted_2,
        _createVNode(_component_LpButton, {
          title: _ctx.$t('dashboard.console.common.downloadXlsx'),
          iconV2: "",
          iconLeft: "file-download",
          textColor: "black-lp-300",
          textSize: 14,
          flat: "",
          dense: "",
          onClick: ($event: any) => (_ctx.toDownload(_ctx.data, tooltip))
        }, null, 8, ["title", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["disabled"]))
}